/**
 * 国家配置接口
 */
export interface CountryConfig {
  /**
   * @description 国家编码（如 'RU'）
   */
  configKey: string;
  /**
   * @description 国旗URL
   */
  configValue: string;
  /**
   * @description 国家名称（中文）
   */
  stringText: string;
}

/**
 * 品牌配置接口
 */
export interface BrandingConfig {
  /**
   * @description 品牌logo图片URL
   */
  logo: string;
  /**
   * @description 版权信息
   */
  copyright: string;
}

/**
 * 单个域名配置接口
 */
export interface DomainConfig {
  /**
   * @description 域名列表（beta环境和生产环境）
   */
  domains: {
    beta: string[]; // beta环境域名
    production: string[]; // 生产环境域名
  };
  /**
   * @description 默认配置（语言、国家、币种）
   */
  defaults: {
    language: string; // 默认语言
    country: string; // 默认国家
    currency: string; // 默认币种
  };
  /**
   * @description 国家配置（可选）
   */
  countryConfig?: CountryConfig;
  /**
   * @description 本地存储前缀
   */
  storagePrefix: string;
  /**
   * @description 登录页URL（beta和生产环境）
   */
  loginUrl: { beta: string; production: string };
  /**
   * @description 品牌配置
   */
  branding: BrandingConfig;
}

/**
 * 所有域名配置集合
 */
export interface DomainConfigs {
  SINOMOTIVE: DomainConfig; // SINOMOTIVE配置
  CASSCHOICE: DomainConfig; // CASSCHOICE配置
}

// 配置对象
export const DOMAIN_CONFIGS: DomainConfigs = {
  SINOMOTIVE: {
    domains: {
      beta: ['https://sinomotive-beta.casstime.com', 'http://sinomotive-beta.casstime.com'],
      production: ['https://mall.sinomotive.com', 'http://mall.sinomotive.com'],
    },
    defaults: {
      language: 'ru',
      country: 'RU',
      currency: 'RUB',
    },
    countryConfig: {
      configKey: 'RU',
      configValue: 'https://fe-static.cassmall.com/assets/images/20240809093532/ru.png',
      stringText: '俄罗斯',
    },
    storagePrefix: 'sino-motive-mall-',
    loginUrl: {
      beta: 'https://sinomotive-beta.casstime.com/#/login',
      production: 'https://mall.sinomotive.com/login',
    },
    branding: {
      logo: 'https://fe-static.cassmall.com/assets/images/20250707171532/SinoMotive_logo.png',
      copyright: 'Copyright © 2025 SINOMOTIVE',
    },
  },
  CASSCHOICE: {
    domains: {
      beta: ['https://if2b-beta.casstime.com', 'http://if2b-beta.casstime.com'],
      production: [
        'https://www.casschoice.com',
        'http://www.casschoice.com',
        'https://casschoice.com',
        'http://casschoice.com',
      ],
    },
    defaults: {
      language: 'en_US',
      country: 'SA',
      currency: 'USD',
    },
    storagePrefix: 'if2b-mall-',
    loginUrl: {
      beta: 'https://if2b-beta.casstime/mall/login',
      production: 'https://www.casschoice.com/mall/login',
    },
    branding: {
      logo: 'https://fe-static.cassmall.com/assets/images/20240808152419/海外LOGO@2x.png',
      copyright: 'Copyright © 2025 CassChoice',
    },
  },
};
